import { ServiceGroup } from './../../../../service-groups/service-group.model';
import { IonContent } from '@ionic/angular';
import { UtilsService } from './../../../../core/utils/utils.service';
import { BasicJobListInfo } from './../../../project.service';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
@Component({
    selector: 'app-project-plan-job-list',
    templateUrl: './project-plan-job-list.component.html',
    styleUrls: ['./project-plan-job-list.component.scss'],
})
export class ProjectPlanJobListComponent implements OnInit {
    // Ionic's VirtualScroll can't bind directly to bound properties. Need to work around here
    // CAREFUL! this works by passing the arrays reference and the contents of the array are modified by push
    // to keep Ionic's virtual scroll working
    // FIXME: HACK: we needed to modify the item to contain service group data for display in the virtual scroll
    // this is done wherever this Input is set
    @Input() set items(val: Array<any>) {
        this._displayedJobList = val;
    }
    @Input() set activeId(val: string) {
        if (this._activeId != val) {
            this._activeId = val;
            // scroll to item

            if (this.itemListViewPort && this.listContainer) {
                // as well as scroll to the point in the list where the job is located
                let itemIndex = this._displayedJobList.findIndex((i) => i.marker._id == this._activeId);
                this.itemListViewPort.scrollToIndex(itemIndex);
            }
        }
    }

    _displayedJobList: Array<any> = [];
    _activeId: string;
    _serviceGroups: Array<ServiceGroup>;

    @Output() itemSelected = new EventEmitter<any>();
    @ViewChild('listContainer') listContainer: IonContent;
    @ViewChild('itemList') itemListViewPort: CdkVirtualScrollViewport;

    constructor(public utils: UtilsService) {}

    ngOnInit() {
        // console.log('init project plan job list');
        // this.displayedJobList = this.jobList;
    }

    // Return the "tracking id" for the item in the virtual scroll list
    // for optimizing redraws
    jobListTrackBy(index: number, item: any) {
        return item ? item.marker._id : index;
    }

    // Return the item height for virtual scroll items
    // By doing this we reduce a lot of computational work which would be needed for the virtual scroll to determine the items' height
    /**
     * @deprecated CDKVirtualScroll does not use this
     */
    jobItemHeightFn(item, index) {
        return 91;
    }

    /**
     * @deprecated CDKVirtualScroll does not use this
     */
    jobHeaderHeightFn(item, index) {
        return 44;
    }

    jobItemHeaderFn(item: BasicJobListInfo, itemIndex, items: Array<BasicJobListInfo>) {
        if (itemIndex == 0) {
            return { name: item.serviceGroupName, editable: !!item.serviceGroupChangesAllowed };
        } else if (item.serviceGroupId != items[itemIndex - 1].serviceGroupId) {
            return { name: item.serviceGroupName, editable: !!item.serviceGroupChangesAllowed };
        }
        return null;
    }

    onJobListItemSelect(item: any) {
        this._activeId = item.marker._id;
        this.itemSelected.emit(item);
    }
}
